import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=5e334618&scoped=true&"
import script from "./SimpleModal.vue?vue&type=script&lang=ts&"
export * from "./SimpleModal.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SimpleModal.vue?vue&type=style&index=1&id=5e334618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e334618",
  null
  
)

export default component.exports